// ABOUTME: Ory Kratos FrontendApi client for the in-app auth screens.
// ABOUTME: withCredentials so the session + CSRF cookies ride along on every flow request.

import { Configuration, FrontendApi } from "@ory/client"
import config from "@/config"

export const ory = new FrontendApi(
  new Configuration({
    basePath: config.KRATOS_API_URL,
    baseOptions: {
      // Cookies carry the Kratos session and the anti-CSRF token — required for browser flows.
      withCredentials: true,
    },
  }),
)
